import TYPOGRAPHY from "../../../themes/Typography"
import COLORS from '../../../themes/Colors'
import { px2Rem } from "../../../themes/Mixins"

import { Box } from "../../common/Box"
import Title from "../../common/Title"
import Button from '../../common/Button'

export const Wrapper = Box.extend`
  position: relative;
  overflow: hidden;
  padding: ${px2Rem(30)} ${px2Rem(25)} ${px2Rem(50)};

  @media (min-width: 768px) {
    padding: ${px2Rem(106)} 0 ${px2Rem(64)};
  }
`

export const MainTitle = Title.extend`
  margin-bottom: ${px2Rem(20)};
  font-size: ${TYPOGRAPHY.SIZE.xSmall};

  @media (min-width: 768px) {
    font-size: ${TYPOGRAPHY.SIZE.large};
    margin-bottom: ${px2Rem(90)};
    text-align: center;
  }
`

export const QuestionTitle = Title.extend`
  font-family: ${TYPOGRAPHY.TYPE.bold};
  color: ${COLORS.mineShaft};
  line-height: 1.5;
  font-size: ${TYPOGRAPHY.SIZE.xTiny};

  @media (min-width: 375px) and (max-width: 767px) {
    font-size: ${TYPOGRAPHY.SIZE.tiny};
  }

  @media (min-width: 768px) {
    line-height: 0.89;
    font-size: ${TYPOGRAPHY.SIZE.base};
    text-align: center;
    margin-top: ${px2Rem(38)};
  }
`

export const StartButton = Button.extend`
  margin: ${px2Rem(20)} auto 0;
  font-weight: 500;
  line-height: 1.5;
  height: auto;
  width: 100%;
  padding: ${px2Rem(9)} 0;
  font-size: ${TYPOGRAPHY.SIZE.xxTiny};

  @media (min-width: 768px) {
    width: auto;
    padding: ${px2Rem(21)} ${px2Rem(54)};
    font-size: ${TYPOGRAPHY.SIZE.tiny};
  }
`



// WEBPACK FOOTER //
// ./src/components/sections/process/ProcessResponsive.js